export default __webpack_public_path__ + "static/media/login-bg-ff.9289cfc6.jpg";